export const ru = {
    'ad-decline-req': 'Объявления отклонены из-за несоответствия правилам размещения рекламы.',
    'how-to-fix': 'Узнать, как исправить объявление, можно в столбце «Статус».',
    'many-banner-title': 'Измените {count} объявлений, чтобы они прошли модерацию',
    'one-banner-title': 'Измените {count} объявление, чтобы оно прошло модерацию',
    'one-banner-title-hint': 'Рекомендация показывается, потому что объявление не прошло модерацию',
    'open-ad-list': 'Чтобы узнать причины отклонения и исправить их, проверьте оформление и содержание объявлений.',
    'popup-ad-decline-req': 'Объявление отклонено из-за несоответствия правилам размещения рекламы.',
    'several-banner-title-hint': 'Рекомендация показывается, потому что некоторые объявления не прошли модерацию',
    'show-many-banner-button': 'Посмотреть {count} объявлений',
    'show-one-banner-button': 'Посмотреть {count} объявление',
    'show-some-banner-button': 'Посмотреть {count} объявления',
    'simple-title': 'Измените объявление, чтобы оно прошло модерацию',
    'some-banner-title': 'Измените {count} объявления, чтобы они прошли модерацию',
    'twenty-one-banner-title': 'Измените {count} объявление, чтобы они прошли модерацию'
};
